import { ColDef, ColGroupDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import {
    GRADE,
    JOB_LABEL,
    ORG_CHART_HR_MAPPING,
    ORG_CHART_HR_NAME,
} from 'routes/HumanResourcesModule/business/definitions';
import { TEXT_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { getAgentColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { orgChartHrFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { formatDate } from 'helpers/dateHelper';
import { START_DATE } from '../../../helpers/constants';
import { MANTY_COLORS } from 'business/constants';
import { GRADE_ADVANCEMENT_HYPOTHESIS } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/constants';

export const getColDefs = (): (ColDef | ColGroupDef)[] => [
    {
        ...TEXT_FILTER,
        headerName: t(`humanResources.simulation.orgChartHrMapping`),
        field: ORG_CHART_HR_MAPPING,
        valueGetter: (params) => ({
            [ORG_CHART_HR_NAME]: params.data?.[ORG_CHART_HR_NAME],
            [ORG_CHART_HR_MAPPING]: params.data?.[ORG_CHART_HR_MAPPING],
        }),
        valueFormatter: (params) => {
            const orgChartHrName = params.value[ORG_CHART_HR_NAME] || '';
            const orgChartHrMapping = params.value[ORG_CHART_HR_MAPPING];
            return orgChartHrFormatter({
                orgChartHrName,
                orgChartHrMapping,
            });
        },
    },
    getAgentColumn(),
    {
        ...TEXT_FILTER,
        headerName: t(`humanResources.simulation.${JOB_LABEL}`),
        field: JOB_LABEL,
        enableRowGroup: true,
    },
    {
        ...TEXT_FILTER,
        headerName: t(`humanResources.simulation.${GRADE}`),
        field: GRADE,
        enableRowGroup: true,
    },
    {
        ...TEXT_FILTER,
        headerName: t('humanResources.simulation.hypothesis'),
        field: GRADE_ADVANCEMENT_HYPOTHESIS,
        cellRenderer: 'agentHypothesisCellRenderer',
        cellRendererParams: (params: ICellRendererParams) => ({
            label: `${t('humanResources.simulation.agentHypothesis.gradeHypotheses')}: ${formatDate(new Date(params.data.startDate))}`,
            styledColor: MANTY_COLORS.red,
        }),
        enableRowGroup: true,
        filterValueGetter: (params) => {
            return `${t(`humanResources.simulation.agentHypothesis.gradeHypotheses`)} ${formatDate(new Date(params.data[START_DATE]))}`;
        },
        valueFormatter: ({ data }) =>
            `${t('humanResources.simulation.agentHypothesis.gradeHypotheses')}: ${formatDate(new Date(data.startDate))}`,
    },
];
